import React from "react";
import { MuiButton } from "~/Components/Form";
import ImageSection from "./ImgesSection";
import InputText from "./InputText";
import * as Style from "./style";
import { useNavigate, useParams } from "react-router-dom";
import { POST_REQUEST } from "../../../../../HooksApi/useApi";
import { USeInsertDataWithImage } from "../../../../../HookAxios/postData";
import { useSelector } from "react-redux";
import { Box, Button, List, ListItem, ListItemText } from "@mui/material";

import CircularProgress from "@mui/material/CircularProgress";

import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import GetAppIcon from "@mui/icons-material/GetApp";

import { useGetSectionQuiz } from "../../Service/SectionQuiz.service";
import { useQueryClient } from "@tanstack/react-query";
const FormCus = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const token = useSelector((state) => state.Auth.userInfo.token);
  const { idUnit } = useParams();
  const [selectedFiles, setSelectedFiles] = React.useState([]);
  const [expected, setExpected] = React.useState("");
  const [Sucsses, setSucsses] = React.useState(false);
  const [uploadError, setUploadError] = React.useState(false);
  const [expectedError, setExpectedError] = React.useState(false);
  React.useEffect(() => { }, [expected]);
  const {
    mutate: SUbmitUnit,
    status,
    data,
    error,
    isLoading: isLoadingSubmitSectionQuiz,
    isSuccess: isSuccessSumitSectionQuiz,
  } = POST_REQUEST({
    request: (data) =>
      USeInsertDataWithImage("submit_section_quiz", data, {
        Authorization: `Bearer ${token}`,
      }),
    handelOnSettledError,
    handelOnSettledData,
  });
  function handelOnSettledError(error) { }
  function handelOnSettledData(data) {
    setSucsses(true);
    // setTimeout(() => {
    //   navigate(-1);
    // }, 1 000);
  }

  const {
    mutate: mutateSetExpectedDegree,
    isLoading,
    isSuccess: isSuccessExpectedDegree,
  } = POST_REQUEST({
    request: (data) =>
      USeInsertDataWithImage("set_expected_degree", data, {
        Authorization: `Bearer ${token}`,
      }),
    handelOnSettledError,
    handelOnSettledData,
  });

  // @Async calls
  const {
    data: dataGetSectionQuiz,
    isLoading: isLoadingGetSectionQuiz,
    isSuccess: isSuccessGetSectionQuiz,
  } = useGetSectionQuiz({ sessionId: idUnit });

  if (isSuccessExpectedDegree || isSuccessSumitSectionQuiz) {
    queryClient.invalidateQueries({ queryKey: ["get-section-quiz"] });
  }

  const onSubmit = () => {
    if (selectedFiles.length == 0) {
      setUploadError("يرحى رفع ملف الاجابة");
      return;
    } else {
      setUploadError(false);
      const formData = new FormData();
      formData.append("section_id", idUnit);
      // formData.append("the_expected_degree", expected);
      for (let i = 0; i < selectedFiles.length; i++) {
        formData.append("section_image[]", selectedFiles[i]);
      }
      // formData.append("section_image[]", selectedFiles);
      SUbmitUnit(formData);
    }
  };

  const onSubmitExpctedDegree = () => {
    if (expected == "") {
      setExpectedError("هذا الحقل مطلوب");
      return;
    } else {
      setUploadError(false);
      const formData = new FormData();
      formData.append("section_id", idUnit);
      formData.append("expected_degree", expected);
      mutateSetExpectedDegree(formData);
    }
  };

  const STATIC = [
    "هذا الاختبار على نمط الاسئلة الامتحانية للتدرب على معلومات هذه الوحدة فقط.",
    "حمل الاختبار فقط عندما تكون جاهز لإجراءه.  ",
    "حمل ملف الـ pdf واضبط الوقت ولا تتجاوز الوقت المخصص للاختبار المذكور في الملف.  ",
    "عندما تنتهي من الاختبار ادخل العلامة المتوقعة.  ",
    "صور اجوبتك بشكل واضح وحمل الصور على الموقع أو التطبيق للحفظ.  ",

    " عندما تضغط على زر إنهاء الإختبار سوف يظهر لك سلم التصحيح على شكل ملف pdf أو ملف فيديو.",
    "بعد مشاهدتك سلم التصحيح ادخل العلامة التي تعتقد أنك تستحقها.  ",
    "ركز على أخطائك وراجع المعلومات الضرورية لتتمكن من هذه الوحدة بشكل تام.",
  ];

  return (
    <Style.Section>
      <List sx={{ width: "100%", bgcolor: "background.paper" }}>
        {STATIC.map((value) => (
          <ListItem sx={{ display: "flex", gap: "8px", p: 0 }}>
            <FiberManualRecordIcon sx={{ fontSize: "12px" }} />
            <ListItemText primary={value} />
          </ListItem>
        ))}
      </List>

      <a
        href={`${process.env.REACT_APP_BASE_URL}${dataGetSectionQuiz?.file_path}`}
        target="_blank"
      >
        <Button
          sx={{ width: "fit-content", my: "24px", py: "15px" }}
          variant="contained"
        >
          <GetAppIcon />
          <span> أسئلة الاختبار </span>
        </Button>
      </a>
      { }
      {!dataGetSectionQuiz?.is_submitted && isSuccessGetSectionQuiz ? (
        <Box>
          <ImageSection
            selectedFiles={selectedFiles}
            setSelectedFiles={setSelectedFiles}
          />
          {uploadError && (
            <p style={{ fontSize: "12px", marginBottom: "32px", color: "red" }}>
              {uploadError}
            </p>
          )}
          <p style={{ fontSize: "12px", marginBottom: "32px" }}>
            ارفع الملف بصيغة pdf او صورة jpg, png
          </p>
          <Button
            sx={{ width: "fit-content", my: "24px", py: "15px" }}
            variant="contained"
            onClick={onSubmit}
            disabled={Sucsses}
            background={Sucsses && "green"}
          >
            {isLoadingSubmitSectionQuiz ? (
              <>
                <span>جار الارسال ... </span>
                <CircularProgress
                  size={20}
                  sx={{
                    alignSelf: "center",
                    mx: "10px",
                    color: "white",
                  }}
                />
              </>
            ) : (
              <>{Sucsses ? <span>تم الارسال</span> : <span>تقديم</span>}</>
            )}
          </Button>
        </Box>
      ) : null}

      {dataGetSectionQuiz?.is_submitted && isSuccessGetSectionQuiz ? (
        <a
          href={`${process.env.REACT_APP_BASE_URL}${dataGetSectionQuiz?.correction_file_path}`}
          target="_blank"
        >
          <Button
            sx={{ width: "fit-content", my: "24px", py: "15px" }}
            variant="contained"
          >
            <GetAppIcon />
            <span>سلّم التصحيح</span>
          </Button>
        </a>
      ) : null}

      {!dataGetSectionQuiz?.expexted_degree &&
        dataGetSectionQuiz?.is_submitted ? (
        <>
          <InputText expected={expected} setExpected={setExpected} />
          {expectedError && (
            <p style={{ fontSize: "12px", marginBottom: "32px", color: "red" }}>
              {expectedError}
            </p>
          )}
          <MuiButton
            color="#fff"
            width="fit-content"
            padding="8px 20px"
            text={"ارسال التقيم"}
            onClick={onSubmitExpctedDegree}
          />
        </>
      ) : null}
    </Style.Section>
  );
};

export default FormCus;
